"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _ScrunchieMaterialPopup = _interopRequireDefault(require("./ScrunchieMaterialPopup.vue"));
var _scrunchieArrangement = require("@/api/scrunchieArrangement/scrunchieArrangement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ScrunchieMaterial',
  components: {
    ScrunchieMaterialPopup: _ScrunchieMaterialPopup.default
  },
  data: function data() {
    return {
      pagination: {
        currentPage: 1,
        // 默认第几页
        total: 0 // 条数
      },
      queryData: {
        categoryId: null,
        path: [],
        enable: null,
        page: {
          page: 1,
          size: 10
        }
      },
      optionProps: {
        value: 'id',
        label: 'categoryName',
        children: 'children',
        checkStrictly: true
      },
      options: [],
      value: false,
      dataList: []
    };
  },
  created: function created() {
    this.categoryListApi();
    this.getMaterialManagerApi();
  },
  methods: {
    onInquire: function onInquire() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.getMaterialManagerApi();
    },
    onInitialize: function onInitialize() {
      this.queryData.page.page = 1;
      this.queryData.page.size = 10;
      this.queryData = {
        categoryId: null,
        path: [],
        enable: null,
        page: {
          page: 1,
          size: 10
        }
      };
      this.getMaterialManagerApi();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.page.size = val;
      this.getMaterialManagerApi();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page.page = val;
      this.getMaterialManagerApi();
    },
    onAdd: function onAdd() {
      this.$refs.individuationPopup.open({
        type: 'add',
        name: '发圈素材添加'
      });
    },
    onEditor: function onEditor(item) {
      this.$refs.individuationPopup.open({
        type: 'editor',
        id: item.id,
        name: '编辑素材'
      });
    },
    // 上下线
    onSwitchChange: function onSwitchChange(id, value) {
      this.materialUpdateStatus(id, value ? 1 : 0);
    },
    onDelete: function onDelete(val) {
      var _this = this;
      this.$confirm('是否确认删除此素材?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteMaterialManagerApi(Number(val.id));
      });
    },
    copyText: function () {
      var _copyText = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(text) {
        var _this2 = this;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              try {
                // await navigator.clipboard.writeText(text)
                // this.$notify.success({
                //   title: '温馨提示',
                //   message: '拷贝成功'
                // })
                this.$copyText(text).then(function () {
                  _this2.$notify.success({
                    title: '温馨提示',
                    message: '拷贝成功'
                  });
                }).catch(function () {
                  _this2.$notify.success({
                    title: '温馨提示',
                    message: '拷贝失败，请手动复制'
                  });
                });
              } catch (err) {
                alert('拷贝失败，请手动复制');
                this.$notify.success({
                  title: '温馨提示',
                  message: '拷贝失败，请手动复制'
                });
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function copyText(_x) {
        return _copyText.apply(this, arguments);
      }
      return copyText;
    }(),
    onRefresh: function onRefresh() {
      console.log('刷新');
      this.getMaterialManagerApi();
    },
    saveMaterialManagerApi: function () {
      var _saveMaterialManagerApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {};
              _context2.n = 1;
              return (0, _scrunchieArrangement.saveMaterialManagerApi)(params);
            case 1:
              res = _context2.v;
              if (res.code === 0) {
                console.log('res', res);
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t = _context2.v;
              console.log(_t);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, null, [[0, 2]]);
      }));
      function saveMaterialManagerApi() {
        return _saveMaterialManagerApi2.apply(this, arguments);
      }
      return saveMaterialManagerApi;
    }(),
    // 下拉框查询
    categoryListApi: function () {
      var _categoryListApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              params = {};
              _context3.n = 1;
              return (0, _scrunchieArrangement.categoryListApi)(params);
            case 1:
              res = _context3.v;
              if (res.code === 0) {
                this.options = res.data;
              }
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.log(_t2);
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function categoryListApi() {
        return _categoryListApi2.apply(this, arguments);
      }
      return categoryListApi;
    }(),
    // 列表查询
    getMaterialManagerApi: function () {
      var _getMaterialManagerApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4() {
        var params, res, _t3;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              params.categoryId = params.path[params.path.length - 1];
              params.path = params.path.join(',');
              _context4.n = 1;
              return (0, _scrunchieArrangement.getMaterialManagerApi)(params);
            case 1:
              res = _context4.v;
              if (res.code === 0) {
                this.dataList = res.data.data;
                this.dataList.forEach(function (item) {
                  item.pathName = item.pathName.split(',');
                  item.enable = !!item.enable;
                });
                this.pagination.total = res.data.total;
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              console.log(_t3);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function getMaterialManagerApi() {
        return _getMaterialManagerApi2.apply(this, arguments);
      }
      return getMaterialManagerApi;
    }(),
    // 删除
    deleteMaterialManagerApi: function () {
      var _deleteMaterialManagerApi2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(id) {
        var params, res, _t4;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              params = {
                id: id
              };
              _context5.n = 1;
              return (0, _scrunchieArrangement.deleteMaterialManagerApi)(params);
            case 1:
              res = _context5.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '删除成功'
                });
                this.getMaterialManagerApi();
              }
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              console.log(_t4);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function deleteMaterialManagerApi(_x2) {
        return _deleteMaterialManagerApi2.apply(this, arguments);
      }
      return deleteMaterialManagerApi;
    }(),
    // 上下线
    materialUpdateStatus: function () {
      var _materialUpdateStatus2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(id, enable) {
        var params, res, _t5;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              params = {
                id: id,
                enable: enable
              };
              _context6.n = 1;
              return (0, _scrunchieArrangement.materialUpdateStatus)(params);
            case 1:
              res = _context6.v;
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.getMaterialManagerApi();
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t5 = _context6.v;
              console.log(_t5);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function materialUpdateStatus(_x3, _x4) {
        return _materialUpdateStatus2.apply(this, arguments);
      }
      return materialUpdateStatus;
    }()
  }
};